const breakpoints = {
  mobile: 769,
  tablet: 1024,
  large: 1440,
}

const checkIfMobile = () => {
  return window.innerWidth < breakpoints.mobile
}
const checkIfTablet = () => {
  return window.innerWidth < breakpoints.tablet
}
const checkIfLarge = () => {
  return window.innerWidth < breakpoints.large
}

export default {
  install(Vue) {
    const device = Vue.observable({
      mobile: checkIfMobile(),
      tablet: checkIfTablet(),
      large: checkIfLarge(),
    })

    const updateDevice = () => {
      device.mobile = checkIfMobile()
      device.tablet = checkIfTablet()
      device.large = checkIfLarge()
    }

    window.addEventListener('resize', updateDevice)

    Vue.prototype.$device = {
      get mobile() {
        return device.mobile
      },
      get tablet() {
        return device.tablet
      },
      get large() {
        return device.large
      },

      get currentSize() {
        if (device.mobile) {
          return 'mobile'
        } else if (device.tablet) {
          return 'tablet'
        } else if (device.large) {
          return 'large'
        }
      },
    }
  },
}
